import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const defaultDimension = classNames(
  'bg-white',
  'rounded',
  '!py-0.5',
  '!px-2',
  'md:!py-2',
  'md:!px-4',
  'absolute',
  'text-secondaryBlue',
  'font-bold',
  'text-xs',
  'sm:text-sm',
);

const styles = {
  component: (
    className: ClassNameType,
  ) => className,
  toggleSection: classNames(
    'sm:flex',
    'justify-between',
    'content-center',
    '!mt-7',
  ),
  toggleButton1: classNames(
    '!mr-2',
    'lowercase',
  ),
  toggleButton2: classNames(
    'lowercase',
  ),
  inputsBlock: classNames(
    'grid',
    'grid-cols-2',
    'sm:grid-cols-3',
    'gap-x-8',
    'sm:gap-x-4',
    'gap-y-4',
  ),
  unitToggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:flex',
    'justify-between',
  ),
  dimensionWidth: classNames(
    defaultDimension,
    'arrow-up',
    'mt-[200px]',
    '-ml-[230px]',
    'sm:mt-[300px]',
    'sm:ml-[400px]',
    'md:mt-[230px]',
    'md:ml-[-260px]',
    'lg:mt-[280px]',
    'lg:ml-[-310px]',
  ),
  dimensionLength: classNames(
    defaultDimension,
    'arrow-up',
    'mt-[200px]',
    'ml-[230px]',
    'sm:mt-[300px]',
    'sm:ml-[-400px]',
    'md:mt-[230px]',
    'md:ml-[260px]',
    'lg:mt-[280px]',
    'lg:ml-[310px]',
  ),
  dimensionHeight: classNames(
    defaultDimension,
    'arrow-down',
    'mt-[75px]',
    'sm:mt-[150px]',
    'md:mt-[75px]',
    'lg:mt-[150px]',
  ),
};

export default styles;
